// Polyfill Promise.withResolvers for older browsers (Chrome <119, Safari <18)
// Used by @inceptdev/doc-viewer (bundled Mozilla PDF.js viewer shell).
// Can be dropped once the PDF viewer is replaced.
if (!Promise.withResolvers) {
  Promise.withResolvers = function withResolvers<T>() {
    let resolve!: (value: T | PromiseLike<T>) => void;
    let reject!: (reason?: unknown) => void;
    const promise = new Promise<T>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
